import { Dispatch, SetStateAction } from 'react';

type AnchorElement = null | HTMLElement;

type VoidFunctionNoArgs = () => void;
type HandleLocalState<T> = Dispatch<SetStateAction<T>>;

interface IPageTitle {
  pageTitle: string;
}

const TABLE_STYLE = {
  CHECKBOX_PARENT: 'checkboxParent',
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
};

type TABLE_TYPE =
  | typeof TABLE_STYLE.CHECKBOX
  | typeof TABLE_STYLE.CHECKBOX_PARENT
  | typeof TABLE_STYLE.RADIO;

interface IBasicModal {
  isOpen: boolean;
  handleClose: VoidFunctionNoArgs;
}

interface IAdditionalInformationResponse {
  accountCreated: {
    firstName: string;
    lastName: string;
  };
  accountUpdated: {
    firstName: string;
    lastName: string;
  } | null;
  created: string;
  updated: string | null;
}

const MAX_DESCRIPTION_LENGTH = 255;

export type {
  AnchorElement,
  VoidFunctionNoArgs,
  IPageTitle,
  HandleLocalState,
  IBasicModal,
};

export { TABLE_STYLE, MAX_DESCRIPTION_LENGTH };
export type { TABLE_TYPE, IAdditionalInformationResponse };
